ui-bank-search-bank-overlay {
  display: block;
  position: relative;
  height: auto;
  z-index: 11;
  background-color: rgba(0 0 0 / 60%);

  &.hidden {
    display: none;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: $sd-backgroundColor-white;

    @include breakpoint($desktop) {
      display: grid;
      grid-template-columns: 400px 1fr;
    }
  }

  .form-content {
    height: calc(100vh - 205px);
    width: 100%;
    padding: $sd-spacing-6 $sd-spacing-4;

    @include breakpoint($medium) {
      padding: $sd-spacing-6 $sd-spacing-8;
    }

    @include breakpoint($desktop) {
      padding: $sd-spacing-6 $sd-spacing-4;
    }

    @include breakpoint($desktop) {
      height: 100%;

      &__container {
        width: 70%;
        margin: 0 auto;
      }
    }

    &__form-title {
      display: flex;
      align-items: center;
      margin: $sd-spacing-6 0;

      @include breakpoint($desktop) {
        margin-top: $sd-spacing-12;
      }

      // Do not remove until webforms are migrated
      ui-icon {
        min-height: 3.125rem;
        min-width: 3.125rem;
        background: $sd-backgroundColor-neutral-100;
        padding: $sd-spacing-1\.5;
        border-radius: 50%;
        margin-right: $sd-spacing-4;
      }
    }
  }

  .hide {
    display: none;

    @include breakpoint($desktop) {
      display: block;
    }
  }

  &:not(.has-form) {
    width: inherit;

    @include breakpoint($desktop) {
      background-color: transparent;
    }
  }

  @include breakpoint($desktop) {
    display: flex;
    height: var(--map-height-desktop);
    padding: $sd-spacing-4;
  }
}
